import type { Animations, AnimationType, ChildAnimationType } from '@Types/Shared/Button';

import { Link } from '@inertiajs/react';

export const Animation = (props: AnimationType) => {
	const checkLinkTag = (props: AnimationType) => {
		const isLinkOpenNewTab = props.target === '_blank';
		const isReset = props.isReset;
		const externalLink = props.urlType === 'link';

		if (isLinkOpenNewTab || externalLink) {
			return 'a';
		}
		if (isReset) {
			return 'button';
		}

		return Link;
	};

	const childProps: ChildAnimationType = {
		...props,
		...{
			Component: props.as ? props.as : checkLinkTag(props),
		},
	};

	const Components: {
		[key in Animations]: React.ReactNode;
	} = {
		none: <NoAnimation {...childProps} />,
		slideup: <SlideUp {...childProps} />,
		scale: <Scale {...childProps} />,
		shake: <Shake {...childProps} />,
	};

	return <>{Components[props.animation ? props.animation : 'none']}</>;
};

export const NoAnimation = (props: ChildAnimationType) => {
	const { className, href, target, children, Component, type, onClick } = props;
	return (
		<Component className={`${className}`} href={href} target={target} type={type} onClick={onClick}>
			{children}
		</Component>
	);
};

export const SlideUp = (props: ChildAnimationType) => {
	const { className, href, target, children, Component, type, onClick } = props;
	return (
		<Component
			className={`${className} transition-all duration-500 ease-in-out hover:translate-y-[-10px] hover:transition-all group-hover:translate-y-[-10px] group-hover:transition-all`}
			href={href}
			target={target}
			type={type}
			onClick={onClick}
		>
			{children}
		</Component>
	);
};

export const Shake = (props: ChildAnimationType) => {
	const { className, href, target, children, Component, type, onClick } = props;
	return (
		<Component
			className={`${className} hover:animate-shake group-hover:animate-shake`}
			href={href}
			target={target}
			type={type}
			onClick={onClick}
		>
			{children}
		</Component>
	);
};

export const Scale = (props: ChildAnimationType) => {
	const { className, href, target, children, Component, type, onClick } = props;

	return (
		<Component
			className={`${className} hover:animate-scale group-hover:animate-scale`}
			href={href}
			target={target}
			type={type}
			onClick={onClick}
		>
			{children}
		</Component>
	);
};
